import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  Validators,
  UntypedFormArray,
  UntypedFormControl,
  AbstractControl,
  UntypedFormBuilder
} from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {
  EbasketApiMethodTypes,
  EbasketLoyaltySchemeSelectApi,
  EbasketSalesExportSelectApi,
  Providers
} from '@shared/interfaces';
import { SelectApiPopupComponent } from '@shared/select-api-popup/select-api-popup.component';

@Component({
  selector: 'app-imprint-provider-details-settings',
  templateUrl: './imprint-provider-details-settings.component.html',
  styleUrls: ['./imprint-provider-details-settings.component.scss']
})
export class ImprintProviderDetailsSettingsComponent implements OnInit {
  @Input() action: string;
  @Input() parentForm: UntypedFormGroup;
  @Input() loyaltySchemeImprintApiDetails: any;
  @Input() authControlKey: string;
  @Input() provider: string;
  ebasket_mixsale_loyaltyScheme_select_api: any;
  isLoyaltySchemeImprintAddDisabled: boolean = false;

  method_types = [{ id: 1, name: EbasketApiMethodTypes.Get, value: EbasketApiMethodTypes.Get }];
  loyaltySchemeApiDetails: any;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.ebasket_mixsale_loyaltyScheme_select_api = [
      {
        id: 1,
        name: EbasketLoyaltySchemeSelectApi.balanceEnquiry,
        value: EbasketLoyaltySchemeSelectApi.balanceEnquiry,
        isDisabled: false
      }
    ];
    this.initForm();
    this.bindLoyaltySchemeImprintApiDetailsFormGroup();
  }
  initForm() {
    this.parentForm.addControl(
      this.authControlKey,
      this.formBuilder.group({
        loyaltySchemeApiDetails: this.formBuilder.array([])
      })
    );
  }

  bindLoyaltySchemeImprintApiDetailsFormGroup() {
    const control = this.parentForm
      .get(this.authControlKey)
      .get('loyaltySchemeApiDetails') as UntypedFormArray;
    console.log('CONTROL', control);
    if (this.loyaltySchemeImprintApiDetails) {
      this.loyaltySchemeImprintApiDetails.map((apis: any) => {
        let apiDetails = {};
        apiDetails = {
          url: [
            {
              value: apis.url,
              disabled: this.action === 'view' ? true : false
            },
            Validators.required
          ],
          method: [
            {
              value: apis.method,
              disabled: this.action === 'view' ? true : false
            },
            Validators.required
          ],
          selectedApi: [apis.selectedApi]
        };

        control.push(this.formBuilder.group(apiDetails));
        this.ebasket_mixsale_loyaltyScheme_select_api.map((key) => {
          if (key.value === apis.selectedApi) {
            key.isDisabled = true;
          }
        });
      });
      if (this.ebasket_mixsale_loyaltyScheme_select_api.length === control.length) {
        this.isLoyaltySchemeImprintAddDisabled = true;
      }
    }
  }
  openLoyaltySchemeImprintSelectApiPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = this.ebasket_mixsale_loyaltyScheme_select_api.filter(
      (api) => !api.isDisabled
    );
    const dialogRef = this.dialog.open(SelectApiPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result !== '') {
        this.ebasket_mixsale_loyaltyScheme_select_api.map((element: any) => {
          if (element.value === result) {
            element.isDisabled = true;
            // this.tm_gift_card_api_details.push(element);
            const loyaltySchemeApiDetails = this.parentForm
              .get(this.authControlKey)
              .get('loyaltySchemeApiDetails') as UntypedFormArray;
            loyaltySchemeApiDetails.push(this.createLoyaltySchemeApiDetailsFormGroup(result));
            if (
              this.ebasket_mixsale_loyaltyScheme_select_api.length ===
              loyaltySchemeApiDetails.length
            ) {
              this.isLoyaltySchemeImprintAddDisabled = true;
            }
          }
        });
      }
    });
  }
  deleteLoyaltySchemeImprintApiDetailContainer(index: number) {
    const loyaltySchemeApiDetails = this.parentForm
      .get(this.authControlKey)
      .get('loyaltySchemeApiDetails') as UntypedFormArray;
    this.ebasket_mixsale_loyaltyScheme_select_api.map((element: any) => {
      if (element.value === loyaltySchemeApiDetails.value[index].selectedApi) {
        element.isDisabled = false;
      }
    });
    if (loyaltySchemeApiDetails.length > 0) {
      loyaltySchemeApiDetails.removeAt(index);
    } else {
      loyaltySchemeApiDetails.reset();
    }
    if (this.ebasket_mixsale_loyaltyScheme_select_api.length !== loyaltySchemeApiDetails.length) {
      this.isLoyaltySchemeImprintAddDisabled = false;
    }
  }
  private createLoyaltySchemeApiDetailsFormGroup(selectedApi: string): UntypedFormGroup {
    return new UntypedFormGroup({
      url: new UntypedFormControl('', Validators.required),
      method: new UntypedFormControl('', Validators.required),
      selectedApi: new UntypedFormControl(selectedApi)
    });
  }
  isRequired(control: string) {
    let isRequired = false;
    const formControlObject = this.parentForm.get(this.authControlKey).get(control);
    if (formControlObject !== null) {
      if (formControlObject.validator !== null) {
        if (formControlObject.validator({} as AbstractControl) !== null) {
          isRequired = formControlObject.validator({} as AbstractControl).required ? true : false;
        }
      }
    }
    return isRequired ? true : false;
  }
}
